<template>
    <footer class="w-full -mt-24 bg-blue-600">
        <div class="self-gutter">
            <div class="pb-64 text-white pt-88 self-content">
                <div class="flex flex-wrap flex-1 pt-12 -mx-10 gap-x-10">
                    <h2 class="flex items-center pt-20 mx-10 text-white title-2xl" style="margin-right: 50px">
                        {{ $t('footer.title') }}</h2>
                    <a href="tel:+372 626 6260" class="flex items-center pt-20 mx-10">
                        <div>
              <span class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-300 rounded-full">
                <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                    <IconPhoneSVG/>
                </span>
              </span>
                        </div>
                        <div class="ml-16">
                            <span class="block font-normal text-white text-md">{{ $t('footer.call') }}</span>
                            <span class="flex items-end">
                <span class="mr-4 font-normal leading-relaxed text-blue-200 font-base">(+372)</span>
                <span class="block text-lg font-medium text-blue-200 underline font-heading">626 6266</span>
              </span>
                        </div>
                    </a>

                    <!--                    <a href="#" class="flex items-center flex-grow pt-20 mx-10">-->
                    <!--                        <div>-->
                    <!--              <span class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-300 rounded-full">-->
                    <!--                <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">-->
                    <!--                    <IconMessagesSVG/>-->
                    <!--                </span>-->
                    <!--              </span>-->
                    <!--                        </div>-->
                    <!--                        <div class="ml-16">-->
                    <!--                            <span class="block font-normal text-white text-md">{{ $t('footer.chat') }}</span>-->
                    <!--                            <span class="flex items-end">-->
                    <!--                <span class="block text-lg font-medium text-blue-200 underline font-heading">{{-->
                    <!--                        $t('footer.online_chat')-->
                    <!--                    }}</span>-->
                    <!--              </span>-->
                    <!--                        </div>-->
                    <!--                    </a>-->

                    <!--                    <a href="https://www.estravel.ee/pakkumine/" class="flex items-center flex-grow pt-20 mx-10">-->
                    <!--                        <div>-->
                    <!--              <span class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-300 rounded-full">-->
                    <!--                <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">-->
                    <!--                    <IconMessagesSVG/>-->
                    <!--                </span>-->
                    <!--              </span>-->
                    <!--                        </div>-->
                    <!--                        <div class="ml-16">-->
                    <!--                            <span class="block font-normal text-white text-md">{{ $t('footer.write') }}</span>-->
                    <!--                            <span class="flex items-end">-->
                    <!--                <span-->
                    <!--                    class="block text-lg font-medium text-blue-200 underline font-heading">{{ $t('footer.web_form') }}</span>-->
                    <!--              </span>-->
                    <!--                        </div>-->
                    <!--                    </a>-->

                    <a href="mailto:estravel@estravel.ee" class="flex items-center pt-20 mx-10">
                        <div>
              <span class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-300 rounded-full">
                <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                    <IconMailSVG/>
                </span>
              </span>
                        </div>
                        <div class="ml-16">
                            <span class="block font-normal text-white text-md">{{ $t('footer.mail') }}</span>
                            <span class="flex items-end">
                <span class="block text-lg font-medium text-blue-200 underline font-heading">estravel@estravel.ee</span>
              </span>
                        </div>
                    </a>
                </div>

                <div class="w-full pt-32 mt-32 border-t border-blue-150 opacity-10"></div>

                <ul class="flex flex-wrap -mt-12">
                    <li class="hidden pt-12 pr-24 xs:block">
                        <span class="block text-blue-300 font-sm">© {{ new Date().getFullYear() }} Estravel</span>
                    </li>
                    <li class="pt-12 pr-24">
                        <a :href="$t('privacy_link').toString()"
                           class="block text-white font-sm hover:text-blue-200 hover:underline">{{ $t('footer.privacy') }}</a>
                    </li>
                    <li class="pt-12 pr-24">
                        <a :href="$t('cookies_link').toString()"
                           class="block text-white font-sm hover:text-blue-200 hover:underline">{{ $t('footer.manage_privacy') }}</a>
                    </li>
                    <li class="w-full pt-12 pr-24 xs:hidden">
                        <span class="block text-blue-300 font-sm">© {{ new Date().getFullYear() }} Estravel</span>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import IconMessagesSVG from '../assets/static/icons-src/icon-messages.svg'
import IconPhoneSVG from '../assets/static/icons-src/icon-phone.svg'
import IconMailSVG from '../assets/static/icons-src/icon-mail.svg'
@Component({
    components: {
        IconMessagesSVG,
        IconPhoneSVG,
        IconMailSVG
    }
})
export default class FooterComponent extends Vue {
}
</script>
